import { render, staticRenderFns } from "./CreateSignature.vue?vue&type=template&id=4235beb4&scoped=true"
import script from "./CreateSignature.vue?vue&type=script&lang=js"
export * from "./CreateSignature.vue?vue&type=script&lang=js"
import style0 from "./CreateSignature.vue?vue&type=style&index=0&id=4235beb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235beb4",
  null
  
)

export default component.exports